class _ShareService {
  share(provider, shareUrl = "", shareContent = "") {
    switch (provider) {
      case "telegram":
        return this.shareTelegram(shareUrl, shareContent);
      case "viber":
        return this.shareViber(shareUrl, shareContent);
      case "whatsapp":
        return this.shareWhatsApp(shareUrl, shareContent);
      case "email":
        return this.shareEmail();
      case "sms":
        return this.shareSms();
    }
  }

  shareTelegram(shareUrl, shareContent) {
    window.open(
      `https://t.me/share?url=${shareUrl}&text=${shareContent}`,
      "_blank"
    );
  }

  shareViber(shareUrl, shareContent) {
    window.open(`viber://forward?text=${shareUrl} ${shareContent}`, "_blank");
  }

  shareWhatsApp(shareUrl, shareContent) {
    window.open(`https://api.whatsapp.com/send?text=${shareUrl}`, "_blank");
  }
  shareEmail() {
    return {
      needAction: true,
      action: "email",
    };
  }
  shareSms() {
    return {
      needAction: true,
      action: "sms",
    };
  }
}

export const ShareService = new _ShareService();
